export enum userTypes {
    DV = 'dv',
    CREATOR = 'creator',
    EDITOR = 'editor',
    ESTABLISHMENT = 'establishment',
}